/* Shopify newsletter AJAX submission: subscribe without refreshing the page. */
(function () {
  'use strict';

  var SELECTOR = 'form.nsl-form-row';
  var FORM_ID_PREFIX = 'NewsletterSplitForm-';
  var HASH_PREFIX = '#NewsletterSplit-';
  var initialized = new WeakSet();

  function showSuccess(form) {
    var wrapper = form.closest('[data-nsl-form-wrapper]');
    var card = form.closest('[data-nsl-card]');
    var success = card ? card.querySelector('[data-nsl-success]') : null;
    var disclaimer = card ? card.querySelector('[data-nsl-disclaimer]') : null;

    if (wrapper) {
      wrapper.hidden = true;
      wrapper.style.display = 'none';
    }

    if (disclaimer) {
      disclaimer.hidden = true;
      disclaimer.style.display = 'none';
    }

    if (success) {
      success.hidden = false;
      success.classList.add('is-visible');
      success.setAttribute('tabindex', '-1');
      success.focus({ preventScroll: true });
    }
  }

  function returnedFromSuccessfulSignup(form) {
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') !== 'true') return false;
    if (!form.id || form.id.indexOf(FORM_ID_PREFIX) !== 0) return false;

    var sectionId = form.id.slice(FORM_ID_PREFIX.length);
    return window.location.hash === HASH_PREFIX + sectionId;
  }

  function getErrorElement(form) {
    return form.querySelector('[data-nsl-error]');
  }

  function setError(form, message) {
    var error = getErrorElement(form);
    if (!error) return;

    error.textContent = message || '';
    error.hidden = !message;
  }

  function setBusy(form, busy) {
    var button = form.querySelector('button[type="submit"]');
    form.setAttribute('aria-busy', busy ? 'true' : 'false');

    if (button) {
      button.disabled = busy;
      button.setAttribute('aria-disabled', busy ? 'true' : 'false');
    }
  }

  function parseResponseDocument(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function responseShowsSuccess(response, responseDocument, formId) {
    try {
      var finalUrl = new URL(response.url, window.location.origin);
      if (finalUrl.searchParams.get('customer_posted') === 'true') return true;
    } catch (error) {
      // Continue with HTML marker detection.
    }

    var returnedForm = responseDocument.getElementById(formId);
    return Boolean(
      returnedForm &&
      returnedForm.querySelector('[data-nsl-server-status="success"]')
    );
  }

  function responseErrorMessage(responseDocument, formId) {
    var returnedForm = responseDocument.getElementById(formId);
    var returnedError = returnedForm
      ? returnedForm.querySelector('[data-nsl-error]')
      : null;
    var text = returnedError ? returnedError.textContent.trim() : '';

    if (text) return text;

    var genericError = responseDocument.querySelector('.errors, [role="alert"]');
    return genericError ? genericError.textContent.trim() : '';
  }

  async function submitWithoutRefresh(event) {
    event.preventDefault();

    var form = event.currentTarget;
    if (form.dataset.nslSubmitting === 'true') return;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    form.dataset.nslSubmitting = 'true';
    setError(form, '');
    setBusy(form, true);

    try {
      var response = await fetch(form.action, {
        method: (form.method || 'post').toUpperCase(),
        body: new FormData(form),
        credentials: 'same-origin',
        redirect: 'follow',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      var html = await response.text();
      var responseDocument = parseResponseDocument(html);

      if (responseShowsSuccess(response, responseDocument, form.id)) {
        form.reset();
        showSuccess(form);
        return;
      }

      var message = responseErrorMessage(responseDocument, form.id);
      setError(
        form,
        message || 'Shopify could not process this subscription right now. Please try again shortly.'
      );
    } catch (error) {
      setError(
        form,
        'We could not submit your subscription right now. Please check your connection and try again.'
      );
    } finally {
      delete form.dataset.nslSubmitting;
      setBusy(form, false);
    }
  }

  function initializeForm(form) {
    if (!form || initialized.has(form)) return;
    initialized.add(form);

    if (
      form.querySelector('[data-nsl-server-status="success"]') ||
      returnedFromSuccessfulSignup(form)
    ) {
      showSuccess(form);
      return;
    }

    form.addEventListener('submit', submitWithoutRefresh);
  }

  function initializeAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(initializeForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
